

const genericField = {
        metaList:[
            {
                label:'Name',
                link:true,
                routePath:'user-roles'/// routePath is required at start of object
            },
            {
                label:'User Name',
                link:false,
                routePath:''
            },
            {
                label:'Email',
                link:false,
                routePath:''
            },
            {
                label:'Current Country',
                link:false,
                routePath:''
            },
            {
                label:'User Role',
                link:false,
                routePath:''
            },
            {
                label:'Status',
                link:false,
                routePath:''
            }
    ],

    columns: ['name', 'user_name', 'email', 'branch_name', 'user_role_name', 'status'],
};

export default genericField;
